import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-grid',
    templateUrl: 'cs-grid.html',
    host: { 'class': 'grid' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsGridComponent {
}
